import { render, staticRenderFns } from "./PurchasesControlPanel.vue?vue&type=template&id=84eb6100&scoped=true"
import script from "./PurchasesControlPanel.vue?vue&type=script&lang=js"
export * from "./PurchasesControlPanel.vue?vue&type=script&lang=js"
import style0 from "./PurchasesControlPanel.vue?vue&type=style&index=0&id=84eb6100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eb6100",
  null
  
)

export default component.exports